import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { IonIntlTelInputComponent } from './ion-intl-tel-input.component';

@NgModule({
  declarations: [IonIntlTelInputComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, IonicSelectableComponent],
  exports: [IonIntlTelInputComponent],
})
export class IonIntlTelInputModule {}
